import { For } from 'solid-js';
import { SITE } from '../../config/site';
import { PixelIcon } from '../PixelIcon';

export function SocialWindow() {
  return (
    <div class="window-body app-window-body social-window">
      <p>Public places where parts of my work and professional history live:</p>
      <div class="network-list sunken-panel">
        <For each={SITE.socialLinks}>
          {(link) => (
            <a href={link.url} target="_blank" rel="noreferrer" class="network-item">
              <PixelIcon name={link.icon} size={32} />
              <span>
                <strong>{link.label}</strong>
                <small>{link.description}</small>
              </span>
              <b aria-hidden="true">↗</b>
            </a>
          )}
        </For>
      </div>
    </div>
  );
}
